import type { FC } from 'react';
import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const DisabledFormBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-destructive text-white">
      <CircleAlert aria-hidden className="size-3 shrink-0" />
      {t('component:badge.disabledForm')}
    </Badge>
  );
};
